<template>
    <div class="d-flex justify-content-end gap-3 mb-4">
        <!-- <button class="btn btn-danger me-1" @click="redirectToDashboard">
            Go To Dashboard
        </button> -->

        <button v-if="showCreateSkill" class="btn btn-success me-1" @click="createSkill">
            Create New Skill
        </button>

        <button v-if="showSkills" class="btn btn-info me-1" @click="redirectToSkills">
            All Skills
        </button>

        <button v-if="showSendMessage" class="btn btn-primary me-1" @click="sendMessage">
            Send Message
        </button>

        <button v-if="showSkilledPersonSummary" class="btn bg-orange text-white" @click="redirectToSkilledPerson">
            Skilled People Summary
        </button>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { useBreadcrumb } from "@/composables/useBreadcrumb";

// Props
defineProps({
    showCreateSkill: { type: Boolean, default: true },
    showSendMessage: { type: Boolean, default: true },
    showSkilledPersonSummary: { type: Boolean, default: true },
    showSkills: { type: Boolean, default: true },
});

// Router
const router = useRouter();
const route = useRoute();
const { setTrail } = useBreadcrumb();

// Methods
// const redirectToDashboard = () => {
//     router.push({ name: "/" });
// };

const createSkill = () => {
    setTrail([
        { label: 'Skills', icon: 'workspace_premium', route: { name: 'skills', params: { locationid: route.params.locationid } } },
        { label: 'Create Skill', icon: 'add' },
    ]);
    router.push({ name: "create-skill", params: { locationid: route.params.locationid } });
};

const redirectToSkills = () => {
    router.push({ name: "skills", params: { locationid: route.params.locationid } });
};

const redirectToSkilledPerson = () => {
    router.push({ name: "skilled-person-summary", params: { locationid: route.params.locationid } });
};

const sendMessage = () => {
    router.push({ name: "skill-messaging-center", params: { source: 'skill', locationid: route.params.locationid } });
};
</script>

<style scoped>
.bg-orange {
    background-color: #ff8800;
}
</style>